import { send } from '../../../../../../../src/network';
import { type BundleRating } from '../../../../../../../src/types/BundleRating';

export type Params = {
  bundle_id: number;
};

export async function getApiV2CustomersSelfBundleRatingsBundleId(
  params: Params
) {
  return await send<BundleRating>({
    path: `/api/v2/customers/self/bundle_ratings/${params.bundle_id}/`,
    method: 'GET',
  });
}
